import { useFormikContext } from "formik";
import React from "react";
import { labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import TextFieldStyles from "../TextField/TextField.module.css";
import styles from "./SurveyTextarea.module.css";

export default function SurveyTextarea({ field_label, displayLabel, parent, isRequired, characters_range }) {
  const { getFieldProps } = useFormikContext();
  const name = parent ? `${parent}.${field_label}` : field_label;
  
  const fieldProps = getFieldProps(name);
  const value = fieldProps.value || "";
  const charCount = typeof value === 'string' ? value.length : 0;

  const min = characters_range?.min ? parseInt(characters_range.min, 10) : 0;
  const max = characters_range?.max ? parseInt(characters_range.max, 10) : 0;
  
  const isTooSmall = min > 0 && charCount > 0 && charCount < min;
  const isTooMuch = max > 0 && charCount > max;
  const hasError = isTooSmall || isTooMuch;

  return (
    <div className={TextFieldStyles.inputContainer}>
      <label htmlFor={field_label} className={TextFieldStyles.label}>
        {labelName(displayLabel || field_label)}
        {isRequired === "true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}
      </label>
      <textarea
        id={field_label}
        className={`${TextFieldStyles.input} ${hasError ? styles.errorBorder : ""}`}
        rows="4"
        cols="50"
        {...fieldProps}
      ></textarea>
      
      {(min > 0 || max > 0) && (
        <div className={styles.charCounterContainer}>
          <span className={`${styles.minText} ${isTooSmall ? styles.errorText : ""}`}>
            {min > 0 ? `Minimum ${min} characters required.` : ""}
          </span>
          <span className={`${styles.countText} ${isTooMuch ? styles.errorText : ""}`}>
            {max > 0 ? `${charCount} of ${max} max` : ""}
          </span>
        </div>
      )}

      <ErrorMessage name={name} />
    </div>
  );
}
